import { t } from "i18next";

import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import NotesList from "@/src/pages/dealer/components/NoteModal/NotesList";

import {
  MileageUnit,
  NoteDTO,
  PreviousAuctionNoteDTO
} from "@/src/types/types";

interface AuctionNotesPreviewProps {
  notes?: NoteDTO[];
  historyGroups: PreviousAuctionNoteDTO[][];
  currentMileage?: number | null;
  mileageUnit?: MileageUnit;
  onShowAll: () => void;
  /** Panel width. Card omits it (fills the footer); the details page
   *  passes a fixed px. */
  width?: number | string;
  maxHeight?: number;
}

const AuctionNotesPreview = (props: AuctionNotesPreviewProps) => {
  const {
    notes,
    historyGroups,
    currentMileage,
    mileageUnit,
    onShowAll,
    width,
    maxHeight = 320
  } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: "100%",
        ...(width ? { width } : { left: 0, right: 0 }),
        minWidth: 288,
        zIndex: 30,
        display: "flex",
        flexDirection: "column",
        maxHeight,
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px 4px 0 0",
        boxShadow: `0 8px 24px ${theme.palette.divider}, 0 4px 12px ${theme.palette.action.selected}`
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", p: 2 }}>
        <NotesList
          variant="preview"
          notes={notes}
          historyGroups={historyGroups}
          currentMileage={currentMileage}
          mileageUnit={mileageUnit}
        />
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          borderTop: `1px solid ${theme.palette.divider}`
        }}
      >
        <Button
          fullWidth
          variant="text"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onShowAll();
          }}
        >
          {t("general.showAll")}
        </Button>
      </Box>
    </Box>
  );
};

export default AuctionNotesPreview;
